<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Dupliquer</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <mat-label>Nombre de copies</mat-label>
            <div class="slider-container">
                <mat-slider class="duplicate-count-input" [max]="10" [min]="0" [step]="1" [discrete]="true" #ngSlider>
                    <input
                        matSliderThumb
                        [value]="data.duplicateCount"
                        (input)="onSliderValueChange({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"
                        #ngSliderThumb="matSliderThumb" />

                    <input matSliderThumb />
                </mat-slider>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="data" [disabled]="data.duplicateCount === 0">Valider</button>
    </mat-card-actions>
</mat-card>
